/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './forgot-password-component.service';
export * from './forgot-password.component';
export * from './forgot-password.module';
